// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"98f83aca","669":"874676df","787":"aba08555"}[chunkId] + ".chunk.js";
};